<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <div class="titlePu">
      <div>照片墙</div>
    </div>
    <div class="commonLiContainer" v-loading="imgs.loading">
      <el-carousel v-bind:interval="4000" v-bind:initial-index="imgs.index" v-on:change="changeHandler"
        indicator-position="outside" trigger="click" height="100vh" ref="carousel">
        <el-carousel-item v-for="(item, index) in imgs.data" v-bind:key="index">
          <img v-bind:src="item.imageUrl" v-bind:alt="item.describes">
        </el-carousel-item>
      </el-carousel>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import { queryActionList2 } from '@/api/sysinfo'
  export default {
    name: 'LivePhoto',
    data() {
      return {
        imgs: {
          index: 0, // 存储当前饿了么轮播图播放的位置
          data: [] // 存储服务器图片数组
        },
        page: {
          size: 10, // 配置一次请求返回几条数据
          index: 1, // 记录当前是第几页
          total: 0, // 记录总页数
          loading: false, // 是否有加载动画
          isNext: true // 记录是否有下一页
        }
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      getData() {
        var params = {
          position: this.page.size,
          currentIndex: this.page.index
        }
        this.loading = true
        queryActionList2(params).then(res => {
            // console.log(res)
            let { list, total } = res.data
            this.imgs.data = this.imgs.data.concat(list)
            this.page.total = total
            this.page.isNext = this.page.size * this.page.index <= this.page.total
          }).finally(() => {
            this.loading = false
          })
      },
      changeHandler(newIndex, oldIndex) {
        // console.log(newIndex)
        this.imgs.index = newIndex
        if (newIndex > oldIndex) {
        //   console.log('下一张')
          if (newIndex + 1 === this.page.index * this.page.size) {
            // console.log('该发请求获取下一页数据了')
            if (this.page.isNext) {
              this.page.index++
              this.getData()
            }
          }
        }
        // console.log(index < this.page.total)
      }
    },
    components: {
      BottomComponent,
      TopComponent
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* 1、title */
  .titlePu {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .titlePu>div {
    width: 1200px;
    height: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    color: rgba(51, 51, 51, 1);
    font-size: 24px;
    text-align: left;
    font-weight: 500;
    font-family: PingFang-SC-Bold;
  }

  /* 公共 */
  .commonLiContainer {
    width: 1180px;
    margin-left: calc(50% - 590px);
  }

  /* 轮播 */
  .el-carousel--horizontal {
    margin-top: 50px;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel>>>.el-carousel__arrow {
    width: 50px;
    height: 50px;
    font-size: 30px;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .el-carousel>>>.el-carousel__indicators {
    display: none;
  }

  img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Live-Photo.vue